import script from "./ManagementVesselInspection.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementVesselInspection.vue?vue&type=script&setup=true&lang=js"

import "./ManagementVesselInspection.vue?vue&type=style&index=0&id=3f8a6f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8a6f5c"]])

export default __exports__